import { PageHero, ServicesSection, WhySection, HowSection, DarkCTA } from "@/components/Sections";
import { IMAGES } from "@/data/site";

export default function Servizi() {
  return (
    <>
      <PageHero overline="I servizi AXAL" title="Un partner unico per ogni trasporto." img={IMAGES.trasporti}
        subtitle="Dal singolo collo al trasloco completo: soluzioni professionali per privati, professionisti e aziende in tutta Italia." />
      <ServicesSection compact />
      <HowSection />
      <WhySection />
      <DarkCTA />
    </>
  );
}
